import { render, staticRenderFns } from "./UnsecuredLayout.vue?vue&type=template&id=3a5ecbaa&scoped=true&lang=html"
import script from "./UnsecuredLayout.vue?vue&type=script&lang=js"
export * from "./UnsecuredLayout.vue?vue&type=script&lang=js"
import style0 from "./UnsecuredLayout.vue?vue&type=style&index=0&id=3a5ecbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ecbaa",
  null
  
)

export default component.exports